export function bookmarkReturnDestination(target: unknown): string {
    return typeof target === 'string' && target.startsWith('/') && !target.startsWith('//') && !target.includes('\\') ? target : '/';
}
